import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
var _container, _container2, _container3;
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
// src/components/slider.ts
import { sliderAnatomy as parts } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers, cssVar, defineStyle } from "@chakra-ui/styled-system";
import { orient } from "@chakra-ui/theme-tools";
var _createMultiStyleConf = createMultiStyleConfigHelpers(parts.keys),
  defineMultiStyleConfig = _createMultiStyleConf.defineMultiStyleConfig,
  definePartsStyle = _createMultiStyleConf.definePartsStyle;
var $thumbSize = cssVar("slider-thumb-size");
var $trackSize = cssVar("slider-track-size");
var $bg = cssVar("slider-bg");
var baseStyleContainer = defineStyle(function (props) {
  var orientation = props.orientation;
  return _objectSpread({
    display: "inline-block",
    position: "relative",
    cursor: "pointer",
    _disabled: {
      opacity: 0.6,
      cursor: "default",
      pointerEvents: "none"
    }
  }, orient({
    orientation: orientation,
    vertical: {
      h: "100%"
    },
    horizontal: {
      w: "100%"
    }
  }));
});
var baseStyleTrack = defineStyle(function (props) {
  var _disabled, _objectSpread2;
  var orientationStyles = orient({
    orientation: props.orientation,
    horizontal: {
      h: $trackSize.reference
    },
    vertical: {
      w: $trackSize.reference
    }
  });
  return _objectSpread(_objectSpread({}, orientationStyles), {}, (_objectSpread2 = {
    overflow: "hidden",
    borderRadius: "sm"
  }, _defineProperty(_objectSpread2, $bg.variable, "colors.gray.200"), _defineProperty(_objectSpread2, "_dark", _defineProperty({}, $bg.variable, "colors.whiteAlpha.200")), _defineProperty(_objectSpread2, "_disabled", (_disabled = {}, _defineProperty(_disabled, $bg.variable, "colors.gray.300"), _defineProperty(_disabled, "_dark", _defineProperty({}, $bg.variable, "colors.whiteAlpha.300")), _disabled)), _defineProperty(_objectSpread2, "bg", $bg.reference), _objectSpread2));
});
var baseStyleThumb = defineStyle(function (props) {
  var orientation = props.orientation;
  var orientationStyle = orient({
    orientation: orientation,
    vertical: {
      left: "50%",
      transform: "translateX(-50%)",
      _active: {
        transform: "translateX(-50%) scale(1.15)"
      }
    },
    horizontal: {
      top: "50%",
      transform: "translateY(-50%)",
      _active: {
        transform: "translateY(-50%) scale(1.15)"
      }
    }
  });
  return _objectSpread(_objectSpread({}, orientationStyle), {}, {
    w: $thumbSize.reference,
    h: $thumbSize.reference,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "absolute",
    outline: 0,
    zIndex: 1,
    borderRadius: "full",
    bg: "white",
    boxShadow: "base",
    border: "1px solid",
    borderColor: "transparent",
    transitionProperty: "transform",
    transitionDuration: "normal",
    _focusVisible: {
      boxShadow: "outline"
    },
    _disabled: {
      bg: "gray.300"
    }
  });
});
var baseStyleFilledTrack = defineStyle(function (props) {
  var _ref;
  var c = props.colorScheme;
  return _ref = {
    width: "inherit",
    height: "inherit"
  }, _defineProperty(_ref, $bg.variable, "colors.".concat(c, ".500")), _defineProperty(_ref, "_dark", _defineProperty({}, $bg.variable, "colors.".concat(c, ".200"))), _defineProperty(_ref, "bg", $bg.reference), _ref;
});
var baseStyle = definePartsStyle(function (props) {
  return {
    container: baseStyleContainer(props),
    track: baseStyleTrack(props),
    thumb: baseStyleThumb(props),
    filledTrack: baseStyleFilledTrack(props)
  };
});
var sizeLg = definePartsStyle({
  container: (_container = {}, _defineProperty(_container, $thumbSize.variable, "sizes.4"), _defineProperty(_container, $trackSize.variable, "sizes.1"), _container)
});
var sizeMd = definePartsStyle({
  container: (_container2 = {}, _defineProperty(_container2, $thumbSize.variable, "sizes.3.5"), _defineProperty(_container2, $trackSize.variable, "sizes.1"), _container2)
});
var sizeSm = definePartsStyle({
  container: (_container3 = {}, _defineProperty(_container3, $thumbSize.variable, "sizes.2.5"), _defineProperty(_container3, $trackSize.variable, "sizes.0.5"), _container3)
});
var sizes = {
  lg: sizeLg,
  md: sizeMd,
  sm: sizeSm
};
var sliderTheme = defineMultiStyleConfig({
  baseStyle: baseStyle,
  sizes: sizes,
  defaultProps: {
    size: "md",
    colorScheme: "blue"
  }
});
export { sliderTheme };